<template>
    <div class="tw:flex tw:flex-col tw:gap-3 tw:pr-2">
        <div
            v-for="(entrada, idx) in entradas"
            :key="entrada.cart_item_id || idx"
            class="tw:relative tw:rounded-lg tw:p-4 tw:md:pt-2 tw:flex tw:flex-col tw:md:flex-row tw:items-center tw:justify-between tw:gap-4 tw:transition-all tw:duration-300 tw:border-2 tw:mb-3"
            :class="isItemSelected(entrada.cart_item_id)
                ? 'tw:bg-[#f0f9f4] tw:border-[#4ade80]'
                : 'tw:bg-[#fdf8f0] tw:border-transparent'"
        >
            <div
                class="tw:absolute tw:top-0 tw:right-0 tw:text-[9px] tw:font-bold tw:px-2 tw:py-1 tw:rounded-bl-md tw:rounded-tr-md tw:uppercase"
                :class="isItemSelected(entrada.cart_item_id) ? 'tw:bg-[#22c55e] tw:text-white' : 'tw:bg-[#d4b06a] tw:text-white'"
            >
                {{ isItemSelected(entrada.cart_item_id) ? $t('seguroEntradaUnnumbered.badgeSeleccionado') : $t('seguroEntradaUnnumbered.badgeRecomendado') }}
            </div>

            <div class="mt-2 tw:flex tw:items-center tw:gap-4 tw:flex-1 md:mt-0">
                <div class="tw:flex tw:flex-col tw:items-center tw:my-auto tw:gap-8 tw:md:gap-3 tw:flex-shrink-0">
                    <img
                        src="https://storage.compralaentrada.com/seguro/imagenes/logo_gesa.webp"
                        alt="GESA"
                        style="max-height: 35px;"
                    />
                    <div class="tw:flex tw:flex-col tw:items-center tw:justify-center tw:gap-8 tw:md:gap-3 ">
                        <img
                            src="https://storage.compralaentrada.com/seguro/imagenes/logo_ARAG.webp"
                            alt="ARAG"
                            style="max-height: 35px;"
                        />
                        <img
                            src="https://storage.compralaentrada.com/seguro/imagenes/logo_Interlloyd.webp"
                            alt="Interlloyd"
                            style="max-height: 30px;"
                        />
                    </div>
                </div>
                <div class="tw:flex tw:flex-col">
                    <h3 class="tw:sm:text-sm tw:font-black tw:uppercase tw:leading-none tw:mb-1 tw:flex tw:flex-col tw:sm:flex-row tw:gap-1 tw:text-xs">
                        {{ $t('seguroEntradaUnnumbered.titulo') }}
                        <span class="tw:text-[#b9965b]">
                            {{ infoEntradasNominativas?.[idx]?.nombre
                                ? `${infoEntradasNominativas[idx].nombre} ${infoEntradasNominativas[idx].apellidos} ${infoEntradasNominativas[idx].dni ? ' | ' + infoEntradasNominativas[idx].dni : ''} `
                                : `${$t('partido.entrada')} ${entrada.name}`
                            }}
                        </span>
                    </h3>
                    <span
                        class="tw:text-[10px] tw:md:text-xs tw:font-bold tw:flex tw:items-center tw:gap-1 tw:mb-1"
                        :class="isItemSelected(entrada.cart_item_id) ? 'tw:text-[#22c55e]' : 'tw:text-[#e11d48]'"
                    >
                        <i :class="isItemSelected(entrada.cart_item_id) ? 'fas fa-check-circle' : 'fas fa-times-circle'"></i>
                        {{ $t('seguroEntradaUnnumbered.subtituloGarantia') }}
                    </span>
                    <p class="tw:text-[11px] tw:text-gray-600 tw:leading-tight">
                        {{ $t('seguroEntradaUnnumbered.descripcion', { reembolso: $t('seguroEntradaUnnumbered.reembolsoDestacado') }) }}
                    </p>
                    <div class="tw:flex tw:flex-wrap tw:gap-1 tw:md:gap-3 tw:mt-1">
                        <div class="tw:flex tw:items-center tw:gap-1 tw:mr-0">
                            <i class="fas fa-check tw:text-green-500 tw:text-[10px]"></i>
                            <span class="tw:text-[10px] tw:font-bold tw:text-gray-700 tw:leading-none">
                                {{ $t('seguroEntradaUnnumbered.motivo1') }}
                            </span>
                        </div>
                        <div class="tw:flex tw:items-center tw:gap-1">
                            <i class="fas fa-check tw:text-green-500 tw:text-[10px]"></i>
                            <span class="tw:text-[10px] tw:font-bold tw:text-gray-700 tw:leading-none">
                                {{ $t('seguroEntradaUnnumbered.motivo2') }}
                            </span>
                        </div>
                        <div class="tw:flex tw:items-center tw:gap-1 tw:mr-0">
                            <i class="fas fa-check tw:text-green-500 tw:text-[10px]"></i>
                            <span class="tw:text-[10px] tw:font-bold tw:text-gray-700 tw:leading-none">
                                {{ $t('seguroEntradaUnnumbered.motivo3') }}
                            </span>
                        </div>
                    </div>
                    <div class="tw:flex tw:flex-wrap tw:flex-col tw:md:flex-row tw:gap-1 tw:md:gap-3 tw:mt-3 tw.md:mt-1">
                        <div class="tw:flex tw:items-center tw:gap-1">
                            <i class="fas fa-file-contract"></i>
                            <a href="https://storage.compralaentrada.com/seguro/documentos/Condiciones%20seguro.pdf" target="_blank" rel="noopener noreferrer" class="tw:text-[10px] tw:font-bold tw:text-red-600" style="text-decoration: underline;">
                                {{ $t('seguroEntradaUnnumbered.verCondiciones') }}
                            </a>
                        </div>
                        <div class="tw:flex tw:items-center tw:gap-1">
                            <i class="fas fa-file-alt"></i>
                            <a href="https://storage.compralaentrada.com/seguro/documentos/protocolo%20siniestro%20seguro%20de%20anulacion%20de%20entrada.pdf" target="_blank" rel="noopener noreferrer" class="tw:text-[10px] tw:font-bold tw:text-red-600" style="text-decoration: underline;">
                                {{ $t('seguroEntradaUnnumbered.verGuia') }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tw:flex tw:flex-row tw:md:flex-col tw:items-end tw:gap-6 tw:md:gap-3">
                <div class="tw:flex tw:flex-row-reverse tw:md:flex-col tw:items-center tw:md:items-end tw:gap-3 tw:md:mt-3">
                    <div class="tw:text-right">
                        <div class="tw:text-lg tw:font-black">
                            +{{ entrada.importe_seguro_entrada | formatear_precio }}
                        </div>
                        <div class="tw:text-[9px] tw:uppercase tw:text-gray-400 tw:font-bold">
                            {{ $t('seguroEntradaUnnumbered.porEntrada') }}
                        </div>

                    </div>
                    <div
                        class="tw:w-7 tw:h-7 tw:rounded-full tw:flex tw:items-center tw:justify-center tw:shadow-sm"
                        :class="isItemSelected(entrada.cart_item_id) ? 'tw:bg-[#14532d]' : 'tw:bg-[#b9965b]'"
                    >
                        <i class="fas fa-shield-alt tw:text-white tw:text-xs"></i>
                    </div>
                </div>

                <div
                    role="switch"
                    :aria-checked="isItemSelected(entrada.cart_item_id)"
                    tabindex="0"
                    class="tw:flex tw:items-center tw:bg-white tw:border-2 tw:rounded-md tw:p-0.5 tw:cursor-pointer tw:transition-all tw:w-[100px] tw:h-9"
                    :class="[
                        isItemSelected(entrada.cart_item_id) ? 'tw:border-[#22c55e]' : 'tw:border-gray-300',
                        { 'tw:opacity-50 tw:pointer-events-none': loading }
                    ]"
                    @click="toggleItem(entrada.cart_item_id)"
                    @keydown.enter.prevent="toggleItem(entrada.cart_item_id)"
                    @keydown.space.prevent="toggleItem(entrada.cart_item_id)"
                >
                    <div
                        class="tw:w-10 tw:h-full tw:rounded tw:flex tw:items-center tw:px-1 tw:transition-colors"
                        :class="isItemSelected(entrada.cart_item_id) ? 'tw:bg-[#22c55e]' : 'tw:bg-gray-200'"
                    >
                        <div
                            class="tw:bg-white tw:w-4 tw:h-4 tw:rounded tw:shadow tw:flex tw:items-center tw:justify-center tw:transition-transform"
                            :class="isItemSelected(entrada.cart_item_id) ? 'tw:translate-x-4' : 'tw:translate-x-0'"
                        >
                            <i v-if="isItemSelected(entrada.cart_item_id)" class="fas fa-check tw:text-[#22c55e] tw:text-[8px]"></i>
                        </div>
                    </div>
                    <span class="tw:flex-1 tw:text-center tw:text-[10px] tw:font-black tw:uppercase tw:text-gray-700">
                        {{ isItemSelected(entrada.cart_item_id) ? $t('seguroEntradaUnnumbered.anadido') : $t('seguroEntradaUnnumbered.anadir') }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    const props = defineProps({
        entradas: Array,
        segurosSeleccionados: Array,
        infoEntradasNominativas: Array,
        loading: Boolean
    })

    const emit = defineEmits(['handleSeguro'])

    const isItemSelected = id => {
        return props.segurosSeleccionados.some(s => s.cart_item_id === id && s.seguro);
    }

    const toggleItem = id => {
        const isSelected = isItemSelected(id);
        emit('handleSeguro', { cart_item_id: id, seguro: !isSelected });
    }

</script>
